import * as R from 'ramda'

export const roughlyEquals = R.curry(
  (tolerance, a, b) => (Math.abs(a - b) <= tolerance)
)

export const roughlyDifferent = R.complement(roughlyEquals)
